const s = {
  name: "Membership",
  dimensions: { width: 36, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 36 40" style="enable-background:new 0 0 36 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13.3,5c0,0.7-0.6,1.2-1.2,1.2S10.8,5.7,10.8,5s0.6-1.2,1.2-1.2S13.3,4.3,13.3,5z"/>
		<path class="st0" d="M16,36v-2H8v2H16z"/>
		<path class="st0" d="M16,18c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3s-1.3,3-3,3C17.3,21,16,19.7,16,18z M19,17c-0.6,0-1,0.4-1,1
			s0.4,1,1,1c0.6,0,1-0.4,1-1S19.6,17,19,17z"/>
		<path class="st0" d="M32,19h-6v-2h6V19z"/>
		<path class="st0" d="M26,23h6v-2h-6V23z"/>
		<path class="st0" d="M24,29v6c0,2.8-2.2,5-5,5H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h14c2.8,0,5,2.2,5,5v6h9c1.7,0,3,1.3,3,3v12
			c0,1.7-1.3,3-3,3H24z M2,5v30c0,1.7,1.3,3,3,3h14c1.7,0,3-1.3,3-3v-6h-9c-1.7,0-3-1.3-3-3V14c0-1.7,1.3-3,3-3h9V5c0-1.7-1.3-3-3-3
			H5C3.3,2,2,3.3,2,5z M24,27h9c0.6,0,1-0.4,1-1V14c0-0.6-0.4-1-1-1H13c-0.6,0-1,0.4-1,1v12c0,0.6,0.4,1,1,1h1v-2c0-1.7,1.3-3,3-3h4
			c1.7,0,3,1.3,3,3V27z M22,25c0-0.5-0.5-1-1-1h-4c-0.5,0-1,0.5-1,1v2h6V25z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Membership
};
